import './App.css';
import React, { useState, useEffect, useContext } from 'react';
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";



import Sidebar from './components/Sidebar/Sidebar';
import Navbar from './components/Navbar/Navbar';
import Dashboard from './components/Dashboard/Dashboard';
import Transctions from './components/Transctions/Transctions';
import Footer from './components/Footer/Footer';
import Inbox from './components/Inbox/Inbox';
import { Router, Routes, Route, NavLink, BrowserRouter } from 'react-router-dom';
import NoteState from './components/Context/NoteState';
import ModalShow from './components/ModalShow';
import Currency from './components/Currency/Currency';
import Account from './components/Account/Account';
import ComingSoon from './components/ComingSoon/ComingSoon';

function App() {

    return (
        <NoteState>
            <BrowserRouter>
                <div className="layout">
                    <div className="app">
                        <Sidebar />
                        <div className="rightSide">
                            <Navbar />
                            <Routes>
                                <Route path="/" element={<Dashboard type="Dash"/>} />
                                <Route path="/Transctions" element={<div><Transctions /></div>} />
                                <Route path="/Inbox" element={<Inbox />}></Route>
                                <Route path="/Currency" element={<Currency />} />
                                <Route path="/Account" element={<Account />} />
                                <Route path="/Soon" element={<ComingSoon />} />
                                <Route path="/stats" element={<div><Dashboard type="Stat"/></div>} />
                            </Routes>
                        </div>
                    </div>
                    <Footer className="footer" />
                </div>
            </BrowserRouter>
            <ModalShow />
        </NoteState>
    )
}

export default App;